<template>
  <section class="tag-cloud" :class="{ limited }">
    <tag-badge
      v-for="(tag, index) in tags"
      :key="index"
      :resource="tag"
      class="mr-1"
      :data-cy="dataCy"
      :variant="variant"
      :size="size"
      :include-hashtag="includeHashtag"
    />
  </section>
</template>
<script>
  export default {
    name: 'TagCloud',

    components: {
      TagBadge: () => import('@/Atoms/TagBadge'),
    },

    props: {
      tags: Array,
      limited: Boolean,
      limit: {
        type: Number,
        default: 10,
      },
      dataCy: String,
      variant: {
        type: String,
        default: 'secondary',
      },
      size: {
        type: String,
        default: 'md',
      },
      includeHashtag: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      computedItems() {
        if (!this.limited) {
          return this.tags;
        }

        return this.tags.slice(0, this.limit - 1);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tag-cloud {
    line-height: 2.2;

    &.limited {
      max-height: 4.3em;
      overflow: hidden;
    }
  }
</style>
